<template>
  <div class="newsdiv bgw">
    <div class="htmldiv">
      <div class="st fs28 fbold tcenter mt20 mb50 prelative">
        <div class="stborder dinline-block prelative">
          <div class="tt wd100 pabsolute">
            <div class="dinline-block fbold">
              <span class="tc11">新闻</span>资讯
            </div>
          </div>
        </div>
        <div class="tright pabsolute more">
          <router-link to="/news/index" class="tc12 fs14 fr mr5 hline">进入新闻资讯+</router-link>
        </div>
      </div>


      <div class="cont fs0 pb30 tcenter">
        <NewsItem v-for="(item,index) in news" v-if="index<4" :index="index" :item="item" :key="index"/>
        <NewsItemTwo v-for="(item,index) in news" v-if="index>=4" :index="index" :item="item" :key="index"/>
      </div>
    </div>
  </div>
</template>

<script>
import NewsItem from './news-item.vue'
import NewsItemTwo from './news-item-two.vue'
export default {
  name: "news",
  props:[
    'news',
  ],
  components: {
    NewsItem,
    NewsItemTwo,
  },
}
</script>

<style scoped>
	.more{right: 0;}
</style>



// WEBPACK FOOTER //
// src/components/index/news.vue